import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import IconChevronUp from "./IconChevronUp";
import IconProps from "./IconProps";

import styles from "./Icons.module.css";

function IconChevronDown({ class: cssClass, ...props }: IconProps) {
    return (
        <IconChevronUp class={classname(styles.iconChevronDown, cssClass)} {...props}/>
    );
}

export default IconChevronDown;
